import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { PROMO_FEATURE, PromoState, StateWithPromo } from '../promo-state';

export const getFeatureState: MemoizedSelector<StateWithPromo, PromoState> =
  createFeatureSelector<PromoState>(PROMO_FEATURE);
